import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full gap-6 mx-5 py-5 lg:mx-20 lg:py-10" }
const _hoisted_2 = { class: "flex flex-col gap-6 h-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "text-left font-bold text-[16px]" }, "Listado de inversiones")
], -1)
const _hoisted_4 = { class: "flex justify-between items-center gap-2" }
const _hoisted_5 = { class: "flex flex-col sm:flex-row lg:gap-8 gap-3 sm:items-center items-start w-full" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-[16px]" }, "Filtrar por:")
], -1)
const _hoisted_7 = { class: "flex flex-col items-start sm:flex-row sm:items-center gap-4" }
const _hoisted_8 = { class: "flex flex-row rounded-lg text-button-green items-center justify-start gap-3" }
const _hoisted_9 = { class: "flex flex-row rounded-lg text-button-green items-center justify-start gap-3" }
const _hoisted_10 = {
  key: 0,
  class: "text-center"
}

import { watch, onMounted, ref, Ref } from "vue";
import { storeToRefs } from "pinia";

import useInvestmentStore from "@/stores/investment";

import InvestCard from "@/components/molecules/InvestCard.vue";
import PaginationControl from "@/components/atoms/PaginationControl.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MyInvertionsView',
  setup(__props) {

const investmentStore = useInvestmentStore();
const { investments, pagination, filters } = storeToRefs(investmentStore);

function handleFirstSwitchingClick(option: number) {
  if (option == 1) {
    filters.value.type == ""
      ? (filters.value.type = "COMERCIAL")
      : (filters.value.type = "");
  }
  if (option == 2) {
    filters.value.type == ""
      ? (filters.value.type = "HABITACIONAL")
      : (filters.value.type = "");
  }

  pagination.value.page = 1;
  investmentStore.fetchInvestments();
}

function handleSecondSwitchingClick(option: number) {
  if (option == 1) {
    filters.value.status == ""
      ? (filters.value.status = "DISPONIBLE")
      : (filters.value.status = "");
  }
  if (option == 2) {
    filters.value.status == ""
      ? (filters.value.status = "ARRENDADO")
      : (filters.value.status = "");
  }

  pagination.value.page = 1;
  investmentStore.fetchInvestments();
}

const handleSetPage = (page: number) => {
  pagination.value.page = page;
  investmentStore.fetchInvestments();
};

watch(pagination.value, () => {
  investmentStore.fetchInvestments();
});

onMounted(() => {
  investmentStore.fetchInvestments();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                class: _normalizeClass(["p-2 text-[16px] rounded-full", [
                  _unref(filters).type == 'COMERCIAL'
                    ? 'bg-[#9BB441] border-[#9BB441] border-2 shadow-md text-white '
                    : 'border-[#5E9bb441] border-2 text-[#5E9bb441] ',
                ]]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (handleFirstSwitchingClick(1)))
              }, " Locales ", 2),
              _createElementVNode("button", {
                class: _normalizeClass(["p-2 text-[16px] rounded-full", [
                  _unref(filters).type == 'HABITACIONAL'
                    ? 'bg-[#9BB441] border-[#9BB441] border-2 shadow-md text-white '
                    : 'border-[#5E9bb441] border-2 text-[#5E9bb441] ',
                ]]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (handleFirstSwitchingClick(2)))
              }, " Departamentos ", 2)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                class: _normalizeClass(["p-2 text-[16px] rounded-full", [
                  _unref(filters).status == 'DISPONIBLE'
                    ? 'bg-[#9BB441] border-[#9BB441] border-2 shadow-md text-white'
                    : 'border-[#5E9bb441] border-2 text-[#5E9bb441]',
                ]]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (handleSecondSwitchingClick(1)))
              }, " Disponibles ", 2),
              _createElementVNode("button", {
                class: _normalizeClass(["p-2 text-[16px] rounded-full", [
                  _unref(filters).status == 'ARRENDADO'
                    ? 'bg-[#9BB441] border-[#9BB441] border-2 shadow-md text-white '
                    : 'border-[#5E9bb441] border-2 text-[#5E9bb441] ',
                ]]),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (handleSecondSwitchingClick(2)))
              }, " Arrendados ", 2)
            ])
          ])
        ])
      ]),
      _createElementVNode("span", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(investments), (item, index) => {
          return (_openBlock(), _createBlock(InvestCard, {
            key: index,
            invest: item
          }, null, 8, ["invest"]))
        }), 128)),
        (_unref(investments) && _unref(investments).length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, " La búsqueda no obtuvo ningún resultado. "))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(PaginationControl, {
      selectedPage: _unref(pagination).page,
      perPage: _unref(pagination).per_page,
      totalPages: _unref(pagination).total_pages,
      onSetPage: handleSetPage
    }, null, 8, ["selectedPage", "perPage", "totalPages"])
  ]))
}
}

})